import React from 'react';
import Hero from '../../contains/Hero/Hero';
import HowItWork from '../../contains/howItWork/HowItWork';
import ForEmployers from '../../components/employers-compotents/ForEmployers';
import Support from '../../contains/supportUkraine/Support';
import employersHeroImg from '../../assets/img/employersHeroImg.webp';
import {Helmet, HelmetProvider } from 'react-helmet-async';
import OgImage from "../../assets/img/Og.png";

function EmployersMain({t,handlerSelectModal}) {
  const employersData = {
    capture:t("hero_capture_employers"),
    text:t("hero_description_employers"),
    img:employersHeroImg,
    altImage:t("alt_og_employers")
  }
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("employers_og_title")}</title>
        <meta name="description" content={t("employers_og_description")}></meta>
        <meta property="og:title" content={t("employers_og_title")} />
        <meta property="og:description" content={t("employers_og_description")} />
        <meta property="og:image" content={OgImage} />
        <link rel="canonical" href="https://weexpert.io/" />
      </Helmet>
      <Hero t={t} data={employersData} handlerSelectModal={handlerSelectModal}/>
      <ForEmployers t={t} handlerSelectModal={handlerSelectModal}/>
      <HowItWork t={t}/>
      <Support t={t}/>
    </HelmetProvider>
  );
}

export default EmployersMain;